import React from 'react'

const FormError = props => {
  return (
    <div className="help-form-error my-3 text-error flex items-center">
      {props.error}
    </div>
  )
}

export default FormError
